module.exports = __webpack_public_path__ + "img/006-close-envelope.71398413.svg";